import { setImportNotification} from '../../../../../modules/fleet/components/ModalImportUnits/redux/slice';
import { setImportNotificationTag } from '../../../../../modules/account/.globals/redux/actions';
import { setImportNotificationDriver } from '../../../../../modules/driver/views/driverTable/components/importDriver/redux/slices';
import { setImportNotificationAssets } from '../../../../../modules/manage/.globals/redux/actions';
import { setImportNotificationSubUser } from '../../../../../modules/account/views/subUser/components/importSubUserModal/redux/slice';

export class IMPORTBULK {
    execute = (payload, state, dispatch) => {
        const parsedPayload = JSON.parse(payload);
        const { importType } = parsedPayload;
        
        // Dispatch to appropriate Redux state based on import type
        switch (importType) {
            case 'ImportUnits':
                dispatch(setImportNotification(parsedPayload));
                break;
                
            case 'ImportTags':
                dispatch(setImportNotificationTag(parsedPayload));
                break;

            case 'ImportDrivers':
                dispatch(setImportNotificationDriver(parsedPayload));
                break;

            case 'ImportAssets':
                dispatch(setImportNotificationAssets(parsedPayload));
                break;
                
            case 'ImportUsers':
                dispatch(setImportNotificationSubUser(parsedPayload));
                break;
                
            default:
                dispatch(setImportNotificationTag(parsedPayload));
                break;
        }
        
        return [false, {}];
    };
}